"use strict";
var distill;
(function (distill) {
    var dashboards;
    (function (dashboards) {
        dashboards.DASH_EVENTS = {
            ALIAS_CHANGED: 'alias:changed',
            METRIC_REMOVED: 'metric:removed',
            AI_QUERY_SEND: 'aiQuery:send',
            AI_QUERY_RESULT: 'aiQuery:result',
            AI_QUERY_CLEAR: 'aiQuery:clear',
            REFRESH_RATE_CHANGED: 'refresh:rate_changed'
        };
        let InternalDistillErrorType;
        (function (InternalDistillErrorType) {
            InternalDistillErrorType["UsageLimitExceeded"] = "UsageLimitExceeded";
            InternalDistillErrorType["AuthenticationRequired"] = "AuthenticationRequired";
            InternalDistillErrorType["PlanNotSupported"] = "PlanNotSupported";
        })(InternalDistillErrorType = dashboards.InternalDistillErrorType || (dashboards.InternalDistillErrorType = {}));
        dashboards.DASH_PROPERTY_TYPE = {
            LEGEND_STYLE: 'legendStyle',
            DATASET_SELECTOR: 'datasetSelector',
            FILTERS: 'filtersEditor',
            COLUMN: 'columnSelector',
            METRICS: 'metricsEditor',
            PROJECTION: 'projectionSelector',
            AGGREGATION_FILTERS: 'aggregationFiltersEditor',
            BREAKDOWN_BY_LIMIT: 'breakDownByLimitEditor',
            SORT_ORDER: 'sortOrderEditor',
            COLOR_PALETTE: 'colorPalette',
            SCOPE_ITEMS: 'scopeItemsEditor'
        };
        let DashboardGlobalFilterType;
        (function (DashboardGlobalFilterType) {
            DashboardGlobalFilterType["DateRange"] = "DateRange";
            DashboardGlobalFilterType["Dropdown"] = "Dropdown";
            DashboardGlobalFilterType["NumberRange"] = "NumberRange";
            DashboardGlobalFilterType["Text"] = "Text";
        })(DashboardGlobalFilterType = dashboards.DashboardGlobalFilterType || (dashboards.DashboardGlobalFilterType = {}));
        dashboards.FILTER_OPTIONS_LIMIT = 200;
        dashboards.GLOBAL_FILTER_COMPATIBLE_COLUMN_TYPES = {
            [DashboardGlobalFilterType.DateRange]: ['Date'],
            [DashboardGlobalFilterType.NumberRange]: ['Number'],
            [DashboardGlobalFilterType.Text]: ['Text', 'LongText', 'Number', 'Date', 'Boolean', 'UniqueIdentifier']
        };
        let ComponentType;
        (function (ComponentType) {
            ComponentType["titleBar"] = "titleBar";
            ComponentType["group"] = "group";
            ComponentType["pieChart"] = "pieChart";
            ComponentType["lineChart"] = "lineChart";
            ComponentType["barChart"] = "barChart";
            ComponentType["heading"] = "heading";
            ComponentType["valueLabel"] = "valueLabel";
            ComponentType["webView"] = "webView";
            ComponentType["embeddedDash"] = "embeddedDash";
            ComponentType["table"] = "table";
            ComponentType["distillQuery"] = "distillQuery";
        })(ComponentType = dashboards.ComponentType || (dashboards.ComponentType = {}));
        let InsightTimeGrain;
        (function (InsightTimeGrain) {
            InsightTimeGrain["None"] = "None";
            InsightTimeGrain["Second"] = "Second";
            InsightTimeGrain["Minute"] = "Minute";
            InsightTimeGrain["Hour"] = "Hour";
            InsightTimeGrain["Day"] = "Day";
            InsightTimeGrain["Week"] = "Week";
            InsightTimeGrain["Month"] = "Month";
            InsightTimeGrain["Quarter"] = "Quarter";
            InsightTimeGrain["Year"] = "Year";
        })(InsightTimeGrain = dashboards.InsightTimeGrain || (dashboards.InsightTimeGrain = {}));
    })(dashboards = distill.dashboards || (distill.dashboards = {}));
})(distill || (distill = {}));
